import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKazoo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "-5 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.25408 25.8779L5.28213 20.3267C3.45123 20.2508 1.68313 20.1025 0 19.8896L2.25408 25.8779ZM13.7463 25.8779L16 19.8896C14.3169 20.1025 12.5488 20.2508 10.7179 20.3267L13.7463 25.8779ZM5.35663 20.338L7.99791 26.1052L10.6438 20.3298C9.74131 20.366 8.82545 20.3851 7.89619 20.3851C7.03851 20.3851 6.19171 20.3686 5.35663 20.338Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.36794 10.3394L8.67727 5.00483H14.2805V5.69078L10.1369 11.2032L11.4399 13.4639C11.8393 14.1245 12.3868 14.455 13.0816 14.455C13.4985 14.455 13.9502 14.3196 14.4366 14.0482L16 17.1984C14.7145 18.1639 13.3077 18.6466 11.7786 18.6466C10.5973 18.6466 9.58058 18.3797 8.72959 17.8464C7.87861 17.3127 7.15739 16.4198 6.56676 15.1659L5.36794 12.4988V18.3671H0V0H5.36794V10.3394Z",
		fill: "white"
	})]
});
export default SvgKazoo;
